import { createActionGroup, emptyProps } from '@ngrx/store';
import { props } from '@ngrx/store';
import { User, UserView } from '@core/models/entities/user.models';
import { CancelSubscription, UserSubscription } from '@core/models/entities/subscription.model';
import { Instructor } from '@core/models/entities/instructor.models';

const PREFIX = '[PROFILE]';

export const ProfileActions = createActionGroup({
  source: `${PREFIX} Root`,
  events: {
    initializeProfile: emptyProps(),
    checkUser: emptyProps(),
    patchUser: props<UserView>(),
    saveUser: props<{ user: User | Instructor }>(),
    saveUserSuccess: emptyProps(),
    getSubscription: emptyProps(),
    getSubscriptionSuccess: props<{ subscriptions: UserSubscription[] }>(),
    cancelSubscription: props<CancelSubscription>(),
    cancelSubscriptionSuccess: props<{ sub: UserSubscription }>(),
    cancelSubscriptionFailure: props<{ error: string }>(),
    deleteUser: emptyProps(),
    navigateToView: emptyProps(),
    navigateToIntro: emptyProps(),
    clearUser: emptyProps(),
    error: props<{ error: string }>(),
  },
});
